import React from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import Modal from "../modal";
import UnitInput from "../inputs/unit-input";
const id = "modal-update-rep-maximum";

function UpdateRepMaximumModal(props, { locals }) {
  const { query, editExercise, activeUser } = locals;
  const primary = _.get(query, "primary", "squat");
  const defaultRepMax = _.get(
    editExercise,
    `repMaximums.${primary}`,
    _.get(activeUser, `repMaximums.${primary}`, 0)
  );
  return (
    <form
      action={`/actions/exercise/rep-max/${_.get(editExercise, "_id", "")}`}
      method="POST"
      data-noreset
    >
      <Modal name={id} key={id} width="600px">
        <div className="head">
          <h2 className="alt">Update {_.capitalize(primary)} Rep Maximum</h2>
        </div>

        <div className="body">
          <div className="columns">
            <div className="column" data-col="1/2">
              <input type="hidden" name="primary" value={primary} />
              <UnitInput
                metric="kg"
                imperial="lb"
                className="text-input"
                name="repMax"
                placeholder="Weight"
                min="1"
                defaultValue={_.round(defaultRepMax, 2)}
              />
            </div>

            <div className="column" data-col="1/1">
              <label className="checkbox-input">
                <input type="checkbox" name="overwrite" />
                <span className="checkbox"></span>
                <span className="text">
                  Overwrite current {primary} rep maximum?
                </span>
              </label>
            </div>
          </div>
        </div>

        <div className="foot">
          <div className="columns">
            <div className="column" data-col="1/2">
              <button className="button-input" type="submit">
                Update
              </button>
            </div>

            <div className="column mobile-hidden" data-col="1/2">
              <a className="cancel" href="/actions/refresh?modal=">
                Cancel
              </a>
            </div>
          </div>
        </div>
      </Modal>
    </form>
  );
}

UpdateRepMaximumModal.contextTypes = { locals: PropTypes.object };

export { id };
export { UpdateRepMaximumModal as default };
